import DeviceSpecifications from './DeviceSpecifications';
export default DeviceSpecifications;

